import { formatAddressToStringShort, formatDate, hoursMinFromTime, hoursMinToTimeString } from "../../../contexts/BookingUtilities";
import { cLog, cWarn } from "../CustomLogger";


export const serializeAddress = (data) =>{
    try{
        if('knownOrNew' in data){
            if(data.knownOrNew === '1'){
                if(data.knownAddress){
                    return data.knownAddress.label;    
                }
            }
            else{
                return formatAddressToStringShort(data);
            }
        }
        
    }
    catch(e){
        cLog(data);
        cWarn(e);
    }
    return '';
}

export const serializePickupTime = (data) =>{
    
    try{
        if('asapOrAdvance' in data){
            if(data.asapOrAdvance === '1'){
                return 'ASAP';
            }
            if(data.asapOrAdvance === '2'){
                return hoursMinToTimeString(hoursMinFromTime(data.travelTime))
            }
            if(data.asapOrAdvance === '3'){
                const timeString = hoursMinToTimeString(hoursMinFromTime(data.travelTime));
                const dateString = formatDate(data.travelDate);
                return `${dateString} ${timeString}`;
            }
        }
        
    }
    catch(e){
        cLog(data);
        cWarn(e);
    }
    return '';
}

export const serializePassenger = (data) => {
    try{
        if('existingOrNew' in data){
            if(data.existingOrNew === '1'){
                if(data.knownPassenger){
                    return {
                        name:data.knownPassenger.label,
                        mobile:data.knownPassenger.mobile,
                        email:data.knownPassenger.email
                    }
                }
            }
            if(data.existingOrNew === '2'){
                return {
                    name:`${data.firstName} ${data.lastName}`,
                    mobile:data.mobile,
                    email:data.email
                };
            }
        }
    }
    catch(e){
        cLog(data);
        cWarn(e);
    }
    return {};
}

export const serializeProviderName = (data,fpsAvailable) => {
    try{
        if('agnosticOrSelect' in data){
            if(data.agnosticOrSelect === '1'){
                return 'Any Provider'
            }
            const {provider:providerId=0} = data;
            for(let i=0; i<fpsAvailable.length; i+=1){
                if(providerId === fpsAvailable[i].value){
                    return fpsAvailable[i].label;
                }
            }            
        }
        
    }
    catch(e){
        cLog(data);
        cWarn(e);
    }
    return '';
}
